const SWITCH_USER = "SWITCH_USER"
const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
const DELETE_CUSTOMER = "DELETE_CUSTOMER"
const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS"
const UPDATE_SUBSCRIPTIONS = "UPDATE_SUBSCRIPTIONS"
const DELETE_SUBSCRIPTIONS = "DELETE_SUBSCRIPTIONS"
const SET_OWNED_PRODUCTS = "SET_OWNED_PRODUCTS"
const UPDATE_OWNED_PRODUCTS = "UPDATE_OWNED_PRODUCTS"
const DELETE_OWNED_PRODUCTS = "DELETE_OWNED_PRODUCTS"
const UPDATE_AWS_CREDENTIALS = "UPDATE_AWS_CREDENTIALS"
const DELETE_AWS_CREDENTIALS = "DELETE_AWS_CREDENTIALS"
const UPDATE_GCP_CREDENTIALS = "UPDATE_GCP_CREDENTIALS"
const DELETE_GCP_CREDENTIALS = "DELETE_GCP_CREDENTIALS"
const UPDATE_AZURE_CREDENTIALS = "UPDATE_AZURE_CREDENTIALS"
const DELETE_AZURE_CREDENTIALS = "DELETE_AZURE_CREDENTIALS"
const DISMISS_POPUPS = "DISMISS_POPUPS"
const RESET_POPUPS = "RESET_POPUPS"
const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE"
const RESET_DARK_MODE = "RESET_DARK_MODE"


// when user signs in / out
function switchUser(user) {
  return {
    type: SWITCH_USER,
    user
  }
}

// update customer details (trial details, stripe id etc)
function updateCustomer(customer) {
  return {
    type: UPDATE_CUSTOMER,
    customer
  }
}

// when user signs out
function deleteCustomer() {
  return {
    type: DELETE_CUSTOMER
  }
}

function setSubscriptions(subscriptions) {
  return {
    type: SET_SUBSCRIPTIONS,
    subscriptions
  }
}

function updateSubscriptions(subscriptions) {
  return {
    type: UPDATE_SUBSCRIPTIONS,
    subscriptions
  }
}

// when user signs out
function deleteSubscriptions() {
  return {
    type: DELETE_SUBSCRIPTIONS
  }
}

function setOwnedProducts(ownedProducts) {
  return {
    type: SET_OWNED_PRODUCTS,
    ownedProducts
  }
}

function updateOwnedProducts(ownedProducts) {
  return {
    type: UPDATE_OWNED_PRODUCTS,
    ownedProducts
  }
}

// when user signs out
function deleteOwnedProducts() {
  return {
    type: DELETE_OWNED_PRODUCTS
  }
}


function updateAwsCredentials(awsCredentials) {
  return {
    type: UPDATE_AWS_CREDENTIALS,
    awsCredentials
  }
}

// when user signs out
function deleteAwsCredentials() {
  return {
    type: DELETE_AWS_CREDENTIALS
  }
}

function updateGcpCredentials(gcpCredentials) {
  return {
    type: UPDATE_GCP_CREDENTIALS,
    gcpCredentials
  }
}

// when user signs out
function deleteGcpCredentials() {
  return {
    type: DELETE_GCP_CREDENTIALS
  }
}

function updateAzureCredentials(azureCredentials) {
  return {
    type: UPDATE_AZURE_CREDENTIALS,
    azureCredentials
  }
}

// when user signs out
function deleteAzureCredentials() {
  return {
    type: DELETE_AZURE_CREDENTIALS
  }
}




function dismissPopups(dismissedPopups) {
  return {
    type: DISMISS_POPUPS,
    dismissedPopups
  }
}

function resetPopups() {
  return {
    type: RESET_POPUPS
  }
}

function toggleDarkMode() {
  return {
    type: TOGGLE_DARK_MODE
  }
}

function resetDarkMode() {
  return {
    type: RESET_DARK_MODE
  }
}

export {
  SWITCH_USER,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
  SET_SUBSCRIPTIONS,
  UPDATE_SUBSCRIPTIONS,
  DELETE_SUBSCRIPTIONS,
  SET_OWNED_PRODUCTS,
  UPDATE_OWNED_PRODUCTS,
  DELETE_OWNED_PRODUCTS,
  UPDATE_AWS_CREDENTIALS,
  DELETE_AWS_CREDENTIALS,
  UPDATE_GCP_CREDENTIALS,
  DELETE_GCP_CREDENTIALS,
  UPDATE_AZURE_CREDENTIALS,
  DELETE_AZURE_CREDENTIALS,
  DISMISS_POPUPS,
  RESET_POPUPS,
  TOGGLE_DARK_MODE,
  RESET_DARK_MODE,
}

export {
  switchUser,
  updateCustomer,
  deleteCustomer,
  setSubscriptions,
  updateSubscriptions,
  deleteSubscriptions,
  setOwnedProducts,
  updateOwnedProducts,
  deleteOwnedProducts,
  updateAwsCredentials,
  deleteAwsCredentials,
  updateGcpCredentials,
  deleteGcpCredentials,
  updateAzureCredentials,
  deleteAzureCredentials,
  dismissPopups,
  resetPopups,
  toggleDarkMode,
  resetDarkMode,
}
